export default __webpack_public_path__ + "static/media/print-logo.ef0ae135.png";